import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import ErrorComponent from "../../Components/ErrorComponent";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from "../../Components/ScrollBar";
import { useAuth } from "../../Contexts/AuthContext";
import { CloseOutlined } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";

function ReqMedical1() {
  const {
    setSelectedProcedureClass,
    setSelectedProcedures,
    setMappedProcedures,
    setSelectedPolicy,
    setSelectedOrders,
    getProcedureClass,
    setDisplayAlert,
    selectedPolicy,
    setIsLoading,
    isLoading,
    getOrders,
    setFiles,
    navigate,
  } = useRequestMedicalContext();

  const { getPolicy, policyLoadState, userData } = useAuth();

  const stepOneValidation = selectedPolicy !== undefined;

  const handleNext = async () => {
    if (stepOneValidation) {
      setIsLoading(true);
      setFiles([]);
      setSelectedOrders([]);
      try {
        await getProcedureClass();
        await getOrders();
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
        navigate("/request-medical-test/diagnostic-order");
      }
    }
  };

  let policies = null;
  if (policyLoadState === "load") {
    policies = (
      <div className="w-full flex justify-center items-center py-3">
        <CircularProgress />
      </div>
    );
  } else if (["ISE", "timeout", "retry"].includes(policyLoadState)) {
    policies = (
      <ErrorComponent
        onRetry={() => getPolicy("retry")}
        isLoading={policyLoadState === "retry"}
      />
    );
  } else {
    policies = userData.map((user) => (
      <label id="labl" key={user}>
        <input
          type="radio"
          onChange={(e) => {
            setSelectedPolicy(user);
            setSelectedOrders([]);
            setSelectedProcedures([]);
            setSelectedProcedureClass([]);
            setMappedProcedures();
          }}
          checked={`${user.cardNo}` === `${selectedPolicy?.cardNo}`}
        />
        <div className="mt-3 border rounded-lg p-3 cursor-pointer">
          <div className="text-sm">
            <div className="font-bold">{user.plan.planType}</div>
            <div className="pt-1">{`${user.firstName} ${user.middleName} ${user.lastName} ${user.suffixName}`}</div>
          </div>
        </div>
      </label>
    ));
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            {/* for ui purposes */}
            <CloseOutlined className="invisible" />
            <div className="text-center text-md font-bold flex-1">
              Request Medical Test
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
        </div>
        <div className="w-full p-3">
          <div>
            <CustomizedProgressBar value={14.28} />
          </div>
          <div className="w-full text-sm text-[#60656D] mt-4">
            Who is this medical test for?
          </div>
        </div>
        <ScrollArea.Root className="w-full px-3 rounded overflow-hidden">
          <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-214px)] sm:h-full sm:max-h-[400px] rounded">
            {policies}
          </ScrollArea.Viewport>
          <ScrollBar />
        </ScrollArea.Root>
        <div className="flex w-full p-4 mt-auto sm:justify-end">
          <Button
            disabled={!stepOneValidation || isLoading}
            className={`h-14 w-full sm:w-22.5 ${
              !stepOneValidation || isLoading ? "bg-[#F6F7F7]" : "bg-[#0053CC]"
            } rounded-xl`}
            onClick={handleNext}
          >
            <p
              className={`font-medium font-sans text-xs ${
                !stepOneValidation || isLoading
                  ? "text-[#A3A7AB]"
                  : "text-white"
              }`}
            >
              {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
            </p>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ReqMedical1;
